require('css/clients/registrations/new');
import Swal from 'sweetalert2'
import $ from 'jquery'
import 'jquery-validation/dist/jquery.validate'
import 'jquery-validation/dist/additional-methods'

$(document).ready(function(){
	
	$(document).on('click','.terms-conditions-link',function(e){
		e.preventDefault();
		Swal.fire({
			title: 'Terms and Conditions',
			html: $('.terms-text').html(),
			confirmButtonText: 'Close',
			width: '80%'
		})
	})

	$(document).on('click','.privacy-policy-link',function(e){
		e.preventDefault();
		Swal.fire({
			title: 'Privacy Policy',
			html: $('.privacy-text').html(),
			confirmButtonText: 'Close',
			width: '80%'
		})
	})

	$.validator.addMethod("strong_password", function (value, element) {
    let password = value;
    if (!(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%&])/.test(password))) {
        return false;
    }
    return true;
	}, function (value, element) {
	    let password = $(element).val();
	    if (!(/^(.{6,20}$)/.test(password))) {
	        return 'Password must be between 6 to 20 characters long.';
	    }
	    else if (!(/^(?=.*[A-Z])/.test(password))) {
	        return 'Password must contain at least one uppercase.';
	    }
	    else if (!(/^(?=.*[a-z])/.test(password))) {
	        return 'Password must contain at least one lowercase.';
	    }
	    else if (!(/^(?=.*[0-9])/.test(password))) {
	        return 'Password must contain at least one digit.';
	    }
	    else if (!(/^(?=.*[@#$%&])/.test(password))) {
	        return "Password must contain special characters from @#$%&.";
	    }
	    return false;
	});


	$('.client-sign-up-form').validate({
		rules:{
	    'client[email]': {
	      required: true,
	      email:true
	    },
	    'client[password]': {
	    	required: true,
	    	strong_password: true
	    },
	    'client[password_confirmation]': {
	    	required: true,
	    	equalTo: "#client_password"
	    },
	    'client[mobile_no]': {
	    	required: true
	    },
	    'client[terms_conditions]': {
	    	required: true
	    },
	    'client[privacy_policy]': {
	    	required: true
	    },
	    'client[name]': {
	    	required: true
	    }
	  },
    errorElement: "div",
	  errorPlacement: function(error, element) {
    	$(element).parents('.input-div').append(error);
    	$(error).addClass('invalid-feedback');
		},
		 messages: {
      'client[email]': {
       	required: 'Email is required.',
      },
      'client[password]': {
      	required: 'Password is required.'
      },
      'client[password_confirmation]': {
      	equalTo: 'Confirm password is not equals to password.'
      },
      'client[mobile_no]': {
      	required: 'Mobile no is required.'
      },
      'client[terms_conditions]': {
      	required: 'Terms & conditions check is required.'
      },
      'client[privacy_policy]': {
      	required: 'Privacy policy check is required.'
      },
      'client[name]': {
      	required: 'Name is required.'
      }
    }
  });



})